import React from "react";
import styled from "styled-components";

//assets

//styles
import typographySizes from "styles/typographySizes.js";
import colors from "styles/colors.js";
import mediaQuery from "styles/mediaQuery.js";
import distances from "styles/distances.js";
//components

//utils
import { getContrastColor } from "utils/colorUtils.js";

const SubTitleWrapper = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 100%;
position: relative  ;
left: ${({ textCenter }) => (textCenter ? "50%" : "0%")};
transform: ${({ textCenter }) => (textCenter ? "translateX(-50%)" : "none")};
top: ${({ big }) => (big ? "1rem" : "0rem")};
width: ${({ customWidth }) => customWidth}px;
margin-bottom: ${({ big }) => (big ? "1rem" : "-0.5rem")};
@media (max-width: ${mediaQuery.laptop}) {
  top: ${({ big }) => (big ? "0rem" : "0.5rem")};
  margin-bottom: ${({ big }) => (big ? "0.5rem" : "0.5rem")};
  /* top: 1.6rem; */
}

`;

const SubTitleText = styled.span`
color: ${({ color }) => color};
font-size: ${typographySizes.heading.extraSmall.size.desktop}rem;
text-transform: uppercase;
text-shadow: 0px 0px ${distances.shadowSmallest}rem ${({ color }) => color};
@media (max-width: ${mediaQuery.tablet}) {
  font-size: ${typographySizes.heading.extraSmall.size.mobile}rem;
}
`;

const SubTitle = ({
  firstLine,
  secondLine,
  color,
  customWidth,
  big,
  textCenter,
  className,
}) => {
  return (
    <SubTitleWrapper
      big={big}
      customWidth={customWidth}
      textCenter={textCenter}
      className={className}
    >
      {firstLine && (
        <SubTitleText color={getContrastColor(color)}>{firstLine}</SubTitleText>
      )}
      {secondLine && (
        <SubTitleText color={getContrastColor(color)}>
          {secondLine}
        </SubTitleText>
      )}
    </SubTitleWrapper>
  );
};

export default SubTitle;
